export default __webpack_public_path__ + "static/media/a023-4.2c501d32.png";